import { createSlice } from '@reduxjs/toolkit';

const testSlice = createSlice({
  initialState: {
    state: {
      anotherThing: 'INITIAL ANOTHER THING',
    },
  } as { state: Record<string, unknown> },
  name: 'testSlice',
  reducers: {
    setState: (state, { payload }: { payload: Record<string, unknown> }) => {
      state.state = {
        ...state.state,
        ...payload,
      };
    },
  },
});

export const testActions = testSlice.actions;
export default testSlice.reducer;
